import React, { useEffect, useState } from "react";
import {
  EuiButton,
  EuiButtonEmpty,
  EuiFieldText,
  EuiForm,
  EuiFormRow,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
  useGeneratedHtmlId,
  EuiButtonIcon,
  EuiSpacer,
  EuiAvatar,
  EuiBadge,
  EuiCode,
  EuiCodeBlock,
} from "@elastic/eui";
import OrganizationService from "../../services/organization-service";

const DomainValidate = ({ domainName, props, closeModalProp }) => {
  const [dnsregistry, setDnsRegistry] = useState({});
  const [response, setResponse] = useState("");

  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [responseColor, setResponseColor] = useState("success");

  const modalFormId = useGeneratedHtmlId({ prefix: "modalForm" });

  const closeModal = () => {
    setIsModalVisible(false);
    closeModalProp();
  };
  const showModal = () => setIsModalVisible(true);

  const validateDomain = async (event) => {
    event.preventDefault();
    setLoading(true);

    const token = sessionStorage.getItem("krakenT");
    const data = {
      domainName,
      organizationId: props.data.company,
      subDomain: dnsregistry.label.split(".")[0],
      target: dnsregistry.text,
    };
    OrganizationService.verifyMsDomainByGraph({
      token,
      data,
    })
      .then((response) => {
        const message =
          response.data.status === "success"
            ? "Domain validated succesfully"
            : "Unexpected response format";
        setResponseColor("success");
        setResponse(message);
      })
      .catch((error) => {
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Some error occurred";

        console.error(errorMessage);
        setResponseColor("danger");
        setResponse(errorMessage);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    const token = sessionStorage.getItem("krakenT");
    console.log(props);
    const organizationId = props.data.company;
    OrganizationService.getDomainVerificationDnsRecords({
      token,
      organizationId,
      domainName,
    })
      .then(({ data: { data: dnsRecords } }) => {
        setDnsRegistry(dnsRecords[0]);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [domainName, props]);

  let modal;

  if (isModalVisible) {
    modal = (
      <EuiModal
        onClose={closeModal}
        initialFocus="[name=popswitch]"
        onSubmit={validateDomain}
      >
        <EuiModalHeader>
          <EuiModalHeaderTitle>Verifying domain</EuiModalHeaderTitle>
        </EuiModalHeader>

        <EuiModalBody>
          {domainName}

          <EuiSpacer size="m" />
          <EuiCodeBlock
            language="json"
            fontSize="m"
            paddingSize="m"
            lineNumbers
          >
            {`${JSON.stringify(dnsregistry, null, "\t")}`}
          </EuiCodeBlock>
          {response !== "" && (
            <EuiBadge color={responseColor}>{response}</EuiBadge>
          )}
        </EuiModalBody>

        <EuiModalFooter>
          <EuiButtonEmpty onClick={closeModal}>Cancel</EuiButtonEmpty>

          <EuiButton
            form={modalFormId}
            fill
            isLoading={loading}
            onClick={validateDomain}
          >
            Save
          </EuiButton>
        </EuiModalFooter>
      </EuiModal>
    );
  }

  return (
    <div>
      <EuiButtonIcon
        color="success"
        size="xs"
        display="base"
        iconType="sortRight"
        aria-label="Next"
        onClick={showModal}
      />
      {modal}
    </div>
  );
};

export default DomainValidate;
